import React from 'react';
import { IAppConfig } from './IAppConfig';

// noinspection SpellCheckingInspection
const ctxt = React.createContext<IAppConfig>({} as IAppConfig);

export const AppConfigProvider = ctxt.Provider;
export const AppConfigConsumer = ctxt.Consumer;
